export default "__VITE_ASSET__fnn9R0Z5__"